<template>
  <div class="row col-12">
    <div class="q-mt-xl col-md col-xs-12 col-sm-12 q-mr-xs tabela-grupo">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
        >
          Grupos já Controlados pelo Treinamento
        </span>
        <div
          class="row col-12 justify-end text-brand-5 text-weight-bold q-mb-sm container-input-search"
        >
          <p class="mobile" style="height: 25px"></p>
        </div>
      </div>
      <q-table
        :columns="columns"
        :rows="selected"
        color="primary"
        table-header-class="bg-accent text-weight-bold"
        flat
        :loading="loading"
        row-key="nome"
        class="tabela-tamanho-fixo"
        dense
        :grid="$q.screen.lt.sm"
        :rows-per-page-options="[0]"
        :pagination="initialPagination"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-8">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Nome: </strong>
                    {{ props.row.nome }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Descrição: </strong>
                    {{ props.row.descricao }}</span
                  >
                </div>
                <div class="col-4">
                  <div class="row col-12 justify-end">
                    <q-btn
                      icon="cancel"
                      round
                      color="red"
                      size="lg"
                      flat
                      @click="desassociarGrupo(props.row.id)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.nome }}
          </q-td>
        </template>
        <template v-slot:body-cell-descricao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.descricao }}
          </q-td>
        </template>
        <template v-slot:body-cell-remover="props">
          <q-td :props="props">
            <q-btn
              icon="cancel"
              round
              color="red"
              flat
              :disable="disable"
              @click="desassociarGrupo(props.row.id)"
            />
          </q-td>
        </template>
      </q-table>
    </div>
    <div class="q-mt-xl col-md col-xs-12 col-sm-12 tabela-grupo">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
        >
          Selecionar Novos
        </span>
        <div
          class="row col-12 justify-end text-brand-5 text-weight-bold q-mb-sm container-input-search"
        >
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            type="text"
            v-model="busca"
            class="col-md-5 col-xs-12"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <q-table
        :columns="columns2"
        :rows="disponiveis.data"
        color="primary"
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-bottom
        dense
        row-key="id"
        selection="single"
        class="tabela-tamanho-fixo"
        :loading="loading"
        v-model:selected="selected"
        :grid="$q.screen.lt.sm"
        v-model:pagination="pagination"
        :rows-per-page-options="[0]"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-8">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Nome: </strong>
                    {{ props.row.name }}</span
                  >
                </div>
                <div class="col-4">
                  <div class="row col-12 justify-end">
                    <q-btn
                      :disable="props.selected"
                      icon="add_circle"
                      :color="props.selected ? 'light-green-4' : 'positive'"
                      round
                      size="lg"
                      flat
                      @click="associarGrupo(props.row.id)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr
            :style="props.selected ? 'background: #EFF5F5' : ''"
            class="text-brand-5 text-weight-bold"
          >
            <q-td>
              <span> {{ props.row.name }}</span>
            </q-td>
            <q-td>
              <q-btn
                :disable="props.selected || disable"
                icon="add_circle"
                :color="props.selected ? 'light-green-4' : 'positive'"
                round
                flat
                @click="associarGrupo(props.row.id)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { watch, ref, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "remover",
    label: "Remover",
    align: "center",
  },
];
const columns2 = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "adicionar",
    label: "Adicionar",
    align: "left",
  },
];
export default {
  props: [
    "selecionados",
    "disponiveis",
    "treinamentoId",
    "tamanhoSelecionados",
  ],
  emits: ["buscar", "paginarTabela", "atualizarTabela"],
  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();

    const selected = ref([]);
    const dadosSelecionados = [];
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: props.disponiveis.per_page,
      rowsNumber: props.disponiveis.total,
    });
    let loading = ref(false);
    let disable = ref(false);
    const busca = ref("");

    const associarGrupo = async (id) => {
      try {
        await store.dispatch("treinamento/associarGrupo", {
          id,
          treinamentoId: props.treinamentoId,
        });
        quasar.notify({
          message: "Grupo associado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit("atualizarTabela");
        loading.value = true;
        disable.value = true;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao associar grupo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const desassociarGrupo = async (id) => {
      try {
        await store.dispatch("treinamento/desassociarGrupo", {
          id,
          treinamentoId: props.treinamentoId,
        });
        quasar.notify({
          message: "Grupo desassociado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit("atualizarTabela");
        loading.value = true;
        disable.value = true;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao desassociar grupo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => props.selecionados,
      () => {
        selected.value = props.selecionados;
      }
    );

    watch(
      () => props.disponiveis,
      () => {
        pagination.value.rowsPerPage = props.disponiveis.per_page;
        pagination.value.page = props.disponiveis.current_page;
        pagination.value.rowsNumber = props.disponiveis.total;
        disable.value = false;
        loading.value = false;
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        emit(
          "paginarTabela",
          pagination.value.page,
          pagination.value.rowsPerPage
        );
        disable.value = true;
        loading.value = true;
      }
    );

    watch(
      () => busca.value,
      () => {
        emit("buscar", busca.value);
      }
    );

    return {
      columns,
      columns2,
      selected,
      pagination,
      dadosSelecionados,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      initialPagination: {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 20,
      },
      disable,
      loading,
      busca,
      associarGrupo,
      desassociarGrupo,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}
tbody tr td {
  white-space: pre-wrap;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
@media (max-width: 600px) {
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .mobile {
    display: none;
  }
}
</style>
